const UPDATABLE_USER_FIELDS = ['alternateEmail', 'companyName', 'phoneNumber'];

const isUserRecord = (value: any) => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

const normalizeEmpty = (value: any) => {
  if (value === '' || value === null || value === undefined) {
    return undefined;
  }

  return value;
};

const normalizeUserFieldValue = (field: string, value: any) => {
  if (
    field === 'companyName' &&
    typeof value === 'string' &&
    value.trim() === ''
  ) {
    return undefined;
  }

  return normalizeEmpty(value);
};

const getChangedNestedFields = (current: any, updated: any) => {
  const currentRecord = isUserRecord(current) ? current : undefined;
  const updatedRecord = isUserRecord(updated) ? updated : {};
  const patch: any = {};

  Object.keys(updatedRecord).forEach((key) => {
    const currentValue = normalizeEmpty(currentRecord?.[key]);
    const updatedValue = normalizeEmpty(updatedRecord[key]);

    if (currentValue !== updatedValue) {
      patch[key] = updatedRecord[key];
    }
  });

  return patch;
};

/**
 * Builds a PATCH payload containing only user fields that differ from the current user.
 * Nested objects (Address, preferences) only include changed keys.
 */
export const buildUserPatchPayload = (currentUser: any, updatePayload: any) => {
  const patch: any = {};

  UPDATABLE_USER_FIELDS.forEach((field) => {
    if (updatePayload[field] === undefined) {
      return;
    }

    const currentValue = normalizeUserFieldValue(field, currentUser?.[field]);
    const updatedValue = normalizeUserFieldValue(field, updatePayload[field]);

    if (currentValue !== updatedValue) {
      patch[field] = updatedValue;
    }
  });

  if (isUserRecord(updatePayload.Address)) {
    const addressPatch = getChangedNestedFields(
      currentUser?.Address,
      updatePayload.Address
    );

    if (Object.keys(addressPatch).length > 0) {
      patch.Address = addressPatch;
    }
  }

  if (isUserRecord(updatePayload.preferences)) {
    const preferencesPatch = getChangedNestedFields(
      currentUser?.preferences,
      updatePayload.preferences
    );

    if (Object.keys(preferencesPatch).length > 0) {
      patch.preferences = preferencesPatch;
    }
  }

  return patch;
};
